module.exports = __webpack_public_path__ + "static/media/Slice30@2x.5df8afe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice30@2x.png
// module id = 1459
// module chunks = 0